import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UpdatingStatusService {

    processingStatus; // PROCESSING | COMPLETED
    processingMessage;
    processingError = false;

    private clearStatusTimer;

    constructor() { }
    /**
     * Set status of socket based operation
     */
    setStatus(status, message?, error?) {
        this.processingStatus = status;
        this.processingMessage = message;
        this.processingError = error;

        clearTimeout(this.clearStatusTimer);

        const timeout = this.processingStatus === 'COMPLETED' ? 3000 : 30000;

        this.clearStatusTimer = setTimeout(() => { this.clear(); } , timeout);
    }
  /**Clear status */
    private clear() {
        this.processingStatus = null;
        this.processingMessage = null;
        this.processingError = false;
    }
}
